import { useHistory } from 'react-router-dom';

export const useGoToPath = (path) => {
  const history = useHistory();
  const handleGoToPath = () => {
    history.push(path);
  };
  return { handleGoToPath };
};
